'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    CSS_CLASSES: {
        ODF_HIDDEN: 'odf-hidden',
    },

    selectors: {
        cancellationCardsWrapper: '.cancellation_cards_wrapper',
        cancellationCards: '.cancellation_card',
        cancellationCardCTA: '.cancellation_card_cta',
    },

    events: {
        'tap .close_intermediate_layer': 'onClickIntermediateLayerCloseIcon',
    },

    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },

    TRACKING: {
        CLICK_CLOSE: 'click-close',
        INTERMEDIATE_LAYER_ACTION: 'intermediate-layer',
        CLICK_PARAMS: ['booking', 'type', 'semantic', 'status', 'includes', 'PNR', 'id', 'pag'],
    },

    initialize({parentWidget, options}) {
        this.parentWidget = parentWidget;
        this.model.set({
            bookingID: options.bookingID,
        });
    },

    onClickIntermediateLayerCloseIcon(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setIntermediateLayerVisibility(false);
        this.trackEvent(this.TRACKING.INTERMEDIATE_LAYER_ACTION, this.TRACKING.CLICK_CLOSE);
    },

    renderCancellations(cancellationsData) {
        this.sortCancellationsByPriority(cancellationsData);
        this.$cachedSelectors.cancellationCardsWrapper.empty();
        cancellationsData.map(this.renderCancellationCard.bind(this));
        this.updateDomSelectorsToCache();
    },

    displayCancellationsWithType(typeToDisplay, trackingInfo) {
        this.model.set({
            trackingInfo: trackingInfo,
        });
        this.$cachedSelectors.cancellationCards.map((i, domEl) => {
            const {type} = domEl.dataset;
            domEl.classList.toggle('odf-hidden', type !== typeToDisplay);
        });
    },

    // Sorts a given array of objects with a 'priority' property by ascending property value. Cancellations with undefined priority will go last.
    sortCancellationsByPriority(cancellationCards) {
        cancellationCards.sort((a, b) => a.priority - b.priority);
    },

    renderCancellationCard(cancellationData, cancellationIndex) {
        const templateData = Odigeo._.merge(cancellationData, {
            cancellationIndex,
            keys: this.keys,
            imagePath: Odigeo.UserArea.imagePath,
            humanTripDate: Odigeo._.partial(Odigeo.Utils.formatDate, _, _, true),
            replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
        });
        const cancellationRendered = this.templates.cancellationCard(templateData);
        this.$cachedSelectors.cancellationCardsWrapper.append(cancellationRendered);
        if (cancellationData.options && cancellationData.options.hasCTA) {
            this.bindCancellationCardCTA(cancellationData, cancellationIndex);
        }
    },

    bindCancellationCardCTA({ctaHandler}, index) {
        const $cta = this.$el.find(this.selectors.cancellationCardCTA).filter((i, domEl) => domEl.dataset.cancellationIndex === `${index}`);
        const callback = ctaHandler || Function.prototype;
        $cta.off().on('click', () => {
            callback();
        });
    },

    setIntermediateLayerVisibility(isVisible) {
        this.parentWidget.toggleIntermediateLayerVisibility(isVisible);
    },

    trackEvent(trackingAction, trackingPrefix) {
        const trackingInfo = this.model.get('trackingInfo');
        const label = trackingUtils.composeLabel(trackingPrefix, this.TRACKING.CLICK_PARAMS, trackingInfo);
        trackingUtils.trackEvent(trackingAction, label);
    },
})));
